export enum AuditLogEvent {
  CREATED = 'created',
  DELETED = 'deleted',
  DOWNLOADED = 'downloaded',
  PREVIEWED = 'previewed',
  UPDATED = 'updated',
  EXPORTED = 'exported',
}

export enum AuditLogCategory {
  USER = 'user',
  ROLE = 'role',
  GROUP = 'group',
  ALERT = 'alert',
  WAREHOUSE = 'warehouse',
  WAREHOUSE_CONTACT = 'warehouse-contact',
  TEMPLATE = 'template',
  ORDER = 'order',
}

export enum AuditLogLoaderKey {
  GET_LOG = 'audit-get',
  LIST_LOGS = 'audit-list',
  ACTIVITIES = 'audit-activities',
}
